import {LocaleDictionaryAuth} from "../../interface/auth";

export const auth: LocaleDictionaryAuth = {
    authText1: 'Паспорт РУДН ID - это единый аккаунт для входа в информационные ресурсы РУДН',
    authText2: 'Если у Вас нет корпоративной почты РУДН, создайте аккаунт в РУДН ID и используйте его для входа в личный кабинет в качестве гостя',
    authText3: 'Если у вас есть корпоративная почта РУДН, используйте её для входа в систему',
    continue: 'Продолжить',
    logInAccount: 'Войти в аккаунт',
    askForAccount: 'Уже есть аккаунт RUDN ID?',
    dontHaveAccount: 'Ещё нет аккаунта RUDN ID?',
    loginTitle: 'Электронная почта/номер телефона',
    phoneTitle: 'Email или номер телефона',
    enterPhone: 'Введите номер',
    enterPhoneText: 'Ваш номер телефона будет использоваться для входа в аккаунт',
    loginPlaceholder: 'Введите телефон/почту',
    phonePlaceholder: 'Введите номер телефона',
    passwordPlaceholder: 'Введите пароль',
    password: 'Придумайте пароль',
    passwordsDontMatch: 'Пароли не совпадают',
    forgotPassword: 'Забыли пароль?',
    logIn: 'Войти',
    register: 'Зарегистрироваться',
    registration: 'Регистрация',
    createAccount: 'Создать аккаунт в РУДН ID',
    accountNotFound: 'Аккаунт не найден. Создайте новый в РУДН ID',
    passwordRecovery: 'Восстановление пароля',
    enterLoginForRecovery: 'Введите электронную почту или номер телефона, которые вы указывали при регистрации',
    enterPhoneForRecovery: 'Введите email или номер телефона, которые вы указывали при регистрации',
    checkRecoveryAccount: 'Выберите нужную учетную запись из списка ниже:',
    mailSent: 'Письмо отправлено',
    mailSentText: 'Мы отправили письмо с ссылкой для восстановления пароля по адресу ',
    enterSMSCode: 'Введите код, отправленный на номер ',
    enterCode: 'Подтвердите номер',
    enterMailCode: 'Введите код, отправленный Вам на почту',
    confirmCode: 'Код подтверждения',
    smsCode: 'Код из SMS',
    retryCode: 'Отправить код заново',
    recoveryByEmail: 'Отправили код подтверждения на почту',
    recoveryByPhone: 'Отправили SMS c кодом подтверждения на',
    retrySMSAfter: 'Повторное получение SMS через ',
    SMSSent: 'Отправили SMS c кодом подтверждения на номер ',
    noAccess: 'Нет доступа к почте и телефону',
    IDontHaveAccess: 'У меня нет доступа к этим данным',
    accountHelp1: 'Напишите, пожалуйста, в поддержку на почту',
    accountHelp2: ' support@rudn.ru',
    accountHelp3: ' или ',
    accountHelp4: 'зарегистрируйтесь в системе заново',
    numberConflict: 'Ваш номер привязан к другому аккаунту',
    numberConflictText1: 'Напишите, пожалуйста, в поддержку на почту',
    numberConflictText2: `, укажите свой номер в международном формате и прикрепите к письму справку,
     кому принадлежит номер, или договор на этот номер телефона (копию договора и справку можно получить в офисе мобильного оператора).
      На снимке должны быть: номер, дата заключения договора, печать и подпись представителя оператора связи.`,
    itIsYou: 'Это вы?',
    thisIsMe: 'Да, это я',
    itsNotMe: 'Это не я',
    email: 'E-mail',
    enterMail: 'Введите E-mail',
    enterMailText: 'Если вы забудете пароль, то сможете легко восстановить доступ к аккаунту с помощью электронной почты',
    noAccessToMail: 'Нет доступа к почте',
    mailCodeSent: 'Отправили письмо c кодом подтверждения на почту ',
    newCodeSent: 'Новый код отправлен',
    retryCodeAfter: 'Повторное получение кода через ',
    success: 'Успешно!',
    successText: 'Вы успешно подтвердили аккаунт РУДН ID. Теперь вам доступны все сервисы Университета',
    goToPlatform: 'Перейти к платформе',
    chooseCreateType: 'Выберите способ создания аккаунта в РУДН ID',
    fromStateServices: 'Через ЕСИА',
    fromPersonalData: 'Заполнение  личных данных',
    name: 'Имя',
    surname: 'Фамилия',
    middleName: 'Отчество/Среднее имя (при наличии)',
    birthDate: 'Дата рождения',
    studentCard: 'Номер студенческого билета (при наличии)',
    addStudentCard: 'Добавить еще один студенческий билет',
    groups: 'Группа/ группы (при наличии)',
    personalNumber: 'Табельный номер (при наличии)',
    addPersonalNumber: 'Добавить еще один табельный номер',
    passwordRules: 'Пароль должен состоять из 9 и более символов, включая цифры, буквы латинского алфавита в разных регистрах и специальные символы',
    repeatPassword: 'Повторите пароль',
    createPassword: 'Придумайте пароль для входа в РУДН ID',
    change: ' Изменить',
    loginHint: 'Логином может являться: корпоративная почта в домене @rudn.ru, @pfur.ru, личная эл. почта, мобильный телефон',
    loginCanBe: 'Логином может являться: ',
    corporateMail: 'Корпоративная почта в домене @rudn.ru, @pfur.ru',
    electronicMail: 'Личная эл. почта',
    mobilePhone: 'Мобильный телефон',
    passport: 'Паспорт',
    snils: 'СНИЛС',
    inn: 'ИНН',
    citizenship: 'Гражданство',
    ruPassport: 'Паспорт РФ',
    foreignIdentityCard: 'Иностранный документ',
    series: 'Серия',
    number: 'Номер',
    enterValidPhone: 'Введите корректный номер телефона',
    nothingFound: 'Ничего не найдено',
    sendVerificationCode: 'Подтвердить почту',
    verifiPhoneNumber: 'Подтвердить номер телефона',
    submit: 'Отправить',
    identityCard: 'Документ, удостоверяющий личность',
    documentNumber: 'Номер документа',
    cancel: 'Отмена',
    day: 'День',
    month: 'Месяц',
    year: 'Год',
    phonesDontMatch: 'Номер телефона не совпадает',
    phoneSetSuccessful: 'Номер телефона успешно изменен',
    emailSetSuccessful: 'Электронная почта успешно изменена',
    finish: 'Завершить',
    pageNotFound: 'Страница не найдена',
    returnToPassport: 'Вернуться в RUDN ID',
    passwordSaveSuccess: 'Пароль успешно сохранен',
    needResetPassword: 'Требуется восстановление пароля',

    smsSend: 'SMS отправлено на',
    codeSend: 'Код отправлен на почту',
    enterFromSms:'Введите код из SMS',
    accountBind: 'Связать аккаунт',
    confirmOperationEnterPassword: 'Для подтверждения выполнения операции введите пароль от аккаунта, с этим счетом.',
    selectPrimaryDomain: 'Выберите основной домен учетной записи для связи с данными аккаунтом.',
    bind: 'Связать',
    skipAndGoToProfile: 'Пропустить и зайти в профиль',
    accountsBinding: 'Ваши аккаунты связаны!',
    attention: 'Внимание',
    importedAccountsMessage: 'При связке учетных записей данные будут импортированы из связанного аккаунта',
    emailEnter: 'Почта',
    LoginUnderUserAccount: 'Вход под аккаунтом пользователя',
    selectAccountsMessage: 'Вы можете сменить аккаунт под которым хотите войти в Личный кабинет. Для этого выберите нужную учетную запись из списка ниже:',
    save: 'Сохранить',
    sendAgainIn: 'Отправить код заново',
}
